var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7761 53.9831C67.1643 53.9831 67.479 54.2978 67.479 54.686V57.7788C67.479 58.167 67.1643 58.4817 66.7761 58.4817C60.5958 58.4817 15.7452 58.4817 15.7452 58.4817C9.53393 58.4817 4.49869 53.4465 4.49869 47.2352C4.49869 41.024 9.53393 35.9888 15.7452 35.9888H66.7761C67.1643 35.9888 67.479 36.3035 67.479 36.6917V39.7845C67.479 40.1727 67.1643 40.4874 66.7761 40.4874C60.5958 40.4874 15.7452 40.4874 15.7452 40.4874C12.0184 40.4874 8.99731 43.5085 8.99731 47.2352C8.99731 50.962 12.0184 53.9831 15.7452 53.9831H66.7761Z",
    fill: "#BF360C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7761 31.4902C67.1643 31.4902 67.479 31.8049 67.479 32.1931V35.2858C67.479 35.6741 67.1643 35.9888 66.7761 35.9888C60.5958 35.9888 15.7452 35.9888 15.7452 35.9888C9.53393 35.9888 4.49869 30.9535 4.49869 24.7423C4.49869 18.531 9.53393 13.4958 15.7452 13.4958H66.7761C67.1643 13.4958 67.479 13.8105 67.479 14.1987V17.2915C67.479 17.6797 67.1643 17.9944 66.7761 17.9944C60.5958 17.9944 15.7452 17.9944 15.7452 17.9944C12.0184 17.9944 8.99731 21.0155 8.99731 24.7423C8.99731 28.469 12.0184 31.4902 15.7452 31.4902H66.7761Z",
    fill: "#56310F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7012 53.9831H15.7452C12.0184 53.9831 8.99731 50.962 8.99731 47.2353C8.99731 43.5085 12.0184 40.4874 15.7452 40.4874H65.7012C63.662 44.9859 63.7148 49.4846 65.7012 53.9831Z",
    fill: "#F7E4D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7012 31.4902H15.7452C12.0184 31.4902 8.99731 28.469 8.99731 24.7423C8.99731 21.0155 12.0184 17.9944 15.7452 17.9944H65.7012C63.662 22.493 63.7148 26.9916 65.7012 31.4902Z",
    fill: "#F7E4D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksIcon);
export default __webpack_public_path__ + "static/media/booksIcon.f441c5891f2114f54b684e53492f5ef9.svg";
export { ForwardRef as ReactComponent };